import { Badge } from "../components/ui/badge";
import { PRIORITY_LABEL, STATUS_LABEL, CATEGORY_LABEL } from "../lib/labels";

export function PriorityBadge({ value, className = "" }) {
  return (
    <span
      data-testid={`priority-badge-${value}`}
      className={`prio-${value} px-2 py-0.5 rounded-full text-[0.68rem] font-semibold uppercase tracking-wider ${className}`}
    >
      {PRIORITY_LABEL[value] || value}
    </span>
  );
}

export function StatusBadge({ value }) {
  return (
    <span
      data-testid={`status-badge-${value}`}
      className="inline-flex items-center gap-2 text-xs font-medium"
    >
      <span className={`status-dot status-${value}`} />
      {STATUS_LABEL[value] || value}
    </span>
  );
}

export function CategoryBadge({ value }) {
  return (
    <Badge variant="outline" data-testid={`category-badge-${value}`} className="font-medium">
      {CATEGORY_LABEL[value] || value}
    </Badge>
  );
}
